module.exports = __webpack_public_path__ + "img/RPriest64_ua.d8c58240.webp";